
import {
  defineComponent,
  onMounted,
  onServerPrefetch,
  useSSRContext,
} from 'vue';
import { useStore } from 'src/store';
import Sidebar from 'components/common/Sidebar.vue';
import Toolbar from 'components/common/Toolbar.vue';
import UndefinedServerErrorModal from 'components/common/ServerErrorModal.vue';

export default defineComponent({
  name: 'MainLayout',
  components: {
    UndefinedServerErrorModal,
    Sidebar,
    Toolbar,
  },
  setup() {
    const $store = useStore();

    onServerPrefetch(() => {
      const ssrContext = useSSRContext();
      return $store.dispatch('app/setHost', ssrContext?.req.headers.host);
    });

    onMounted(() => {
      void $store.dispatch('app/setHost', document.location.host);
      // document.location.href = getSignInUrl({
      //   redirectUrl: root.$store.state.app.host,
      // });
    });
  },
});
